import { defineComponent, onUnmounted } from 'vue';

/**
 * Renderless child of the dialog panel. Reka keeps the panel mounted while
 * its exit animation plays, so this unmounts exactly when the panel has left
 * the DOM, which is what `after:leave` reports.
 */
export const ModalLeaveSentinel = defineComponent({
  name: 'ModalLeaveSentinel',
  emits: { leave: () => true },
  setup: (_, { emit }) => {
    onUnmounted(() => emit('leave'));
    return () => null;
  },
});
